// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoHtml_wrapper__IWHMy"};